import axiosClient from "../../config/axiosClient";
import { ENDPOINTS } from "../../config/endpoints";

type NotificationItem = {
  id: string;
  title: string;
  message: string;
  isRead: boolean;
  data?: Record<string, unknown>;
  createdAt: string;
};

type PaginatedNotifications = {
  items: NotificationItem[];
  page: number;
  limit: number;
  total: number;
  totalPages: number;
};

const unwrap = <T>(payload: any): T => {
  if (payload && typeof payload === "object" && "success" in payload && "data" in payload) {
    const level1 = payload.data;
    if (level1 && typeof level1 === "object" && "success" in level1 && "data" in level1) {
      return (level1 as any).data as T;
    }
    return level1 as T;
  }
  return payload as T;
};

class NotificationsApiService {
  async list(params?: { page?: number; limit?: number }): Promise<PaginatedNotifications> {
    const response = await axiosClient.get<{ success: boolean; data: PaginatedNotifications }>(
      ENDPOINTS.NOTIFICATIONS.BASE,
      { params }
    );
    return unwrap<PaginatedNotifications>(response.data);
  }

  async unreadCount(): Promise<{ unreadCount: number }> {
    const response = await axiosClient.get<{ success: boolean; data: { unreadCount: number } }>(
      ENDPOINTS.NOTIFICATIONS.UNREAD_COUNT
    );
    return unwrap<{ unreadCount: number }>(response.data);
  }

  async markRead(id: string): Promise<void> {
    await axiosClient.patch(ENDPOINTS.NOTIFICATIONS.MARK_READ(id));
  }

  async markAllRead(): Promise<void> {
    await axiosClient.patch(ENDPOINTS.NOTIFICATIONS.MARK_ALL_READ);
  }
}

export const notificationsService = new NotificationsApiService();

